import { useContext } from "react";

import { SdkContext } from "./sdk-context";

export const useSdkReady = (): boolean => {
  const context = useContext(SdkContext);

  if (!context) {
    throw new Error("useSdkReady must be used within an SdkProvider");
  }

  return context.ready;
};
